import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { UsuarioService } from 'src/app/core/services/usuario/usuario.service';
import { FiltroActividades } from 'src/app/shared/models/filtroActividades';
import { Login } from 'src/app/shared/models/login';
import { AuthService } from '../../../../core/authentication/auth.service';
import { RedirectService } from '../../../../core/services/redirect/redirect.service';
import * as CryptoJS from 'crypto-js';

declare var $: any;


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  loginForm: FormGroup;

  constructor(private snackBar: MatSnackBar, private router: Router, private usuarioServices: UsuarioService, private authService: AuthService, private form: FormBuilder, private redirectService: RedirectService) {
    $('#spinner-load').css("display", "none");

    this.loginForm = this.form.group({
      username: new FormControl('', [Validators.required]),
      password: new FormControl('', Validators.required)
    });
  }
  ngOnInit() {
  }
  encryptPassword(password: string): string {
    const secretKey = '1234567890abcdef'; // Clave secreta (16 bytes para AES-128)
    const iv = CryptoJS.lib.WordArray.random(16); // Generar IV de 16 bytes

    // Cifrar usando AES en modo CBC con PKCS7Padding
    const encrypted = CryptoJS.AES.encrypt(password, CryptoJS.enc.Utf8.parse(secretKey), {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });

    // Concatenar IV (en Base64) y el texto cifrado (en Base64), separados por ":"
    const encryptedText = `${CryptoJS.enc.Base64.stringify(iv)}:${encrypted.toString()}`;
    return encryptedText;
  }
  onSubmit() {
    const pass = this.encryptPassword(this.loginForm.get('password').value);
    const user = this.loginForm.get('username').value;
    let login = new Login(user, pass);
    this.authService.login(login)
      .subscribe(
        success => {
          if (success.body && success.body.user_ad && success.body.user_ad == 'true') {
            if (success.body.status_code == '400') {
              this.snackBar.open('Ocurrió un error al conectar con el servidor, vuelva a intentar más tarde.', 'X');
            } else
              this.usuarioServices.setData(success.body)
            let filtros = new FiltroActividades();
            localStorage.setItem("ET_EMYRfiltroActividades", JSON.stringify(filtros))
           //this.authService.getTokenApi().subscribe(token => {
              //this.usuarioServices.setgetTokenApi(token.token);
              //this.usuarioServices.setUserCategories(token);

              this.authService.authenticate().subscribe(authenticate => {
                this.usuarioServices.setTokenApi(authenticate.token);

                this.router.navigate(['/']);
              })
            //});


          }else if(success.body  && success.body.user_ad == 'false'){
            this.snackBar.open('El usuario no es valido', 'X');
          }
        },
        err => {
          this.snackBar.open('Ocurrió un error al conectar con el servidor, vuelva a intentar más tarde.', 'X');
        });
  }

  getUsename() {
    return this.loginForm.get('username');
  }

  getPassword() {
    return this.loginForm.get('password');
  }


  mostrarPass() {
    var tipo: any = document.getElementById("password");
    if (tipo.type == "password") {
      tipo.type = "text";
    } else {
      tipo.type = "password";
    }
  }


}
